module.exports = __webpack_public_path__ + "static/img/05.34519d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/znhy/05.jpg
// module id = nCIa
// module chunks = 1